import { render } from "./KindAds.vue?vue&type=template&id=632e33e2&lang=true"
import script from "./KindAds.vue?vue&type=script&lang=js"
export * from "./KindAds.vue?vue&type=script&lang=js"
script.render = render

export default script